import { Activity } from "lucide-react";

export default function EmptyState({
  message = "No data available",
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-10 text-center">
      <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-blue-600">
        <Activity className="h-5 w-5" />
      </div>

      <h3 className="text-sm font-semibold text-slate-900">
        {message}
      </h3>

      <p className="mt-1 max-w-sm text-xs text-slate-500">
        Use the quick actions above to record the first touchpoint.
      </p>
    </div>
  );
}
